import { render } from "./ActionConfig.vue?vue&type=template&id=0a030b32&scoped=true"
import script from "./ActionConfig.vue?vue&type=script&lang=ts"
export * from "./ActionConfig.vue?vue&type=script&lang=ts"

import "./ActionConfig.vue?vue&type=style&index=0&id=0a030b32&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0a030b32"

export default script